module.exports = __webpack_public_path__ + "img/eps.dccfd481.svg";